declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    clarity?: (...args: unknown[]) => void;
  }
}

const GA_SCRIPT_ID = 'ga4-loader';
const CLARITY_SCRIPT_ID = 'clarity-loader';

export const loadGoogleAnalytics = (measurementId: string): void => {
  if (document.getElementById(GA_SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = GA_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer?.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId);
};

export const loadClarity = (projectId: string): void => {
  if (document.getElementById(CLARITY_SCRIPT_ID)) return;

  (function (c: Window, l: Document, a: string, r: string, i: string) {
    (c as any)[a] =
      (c as any)[a] ||
      function (...args: unknown[]) {
        ((c as any)[a].q = (c as any)[a].q || []).push(args);
      };
    const t = l.createElement(r) as HTMLScriptElement;
    t.id = CLARITY_SCRIPT_ID;
    t.async = true;
    t.src = 'https://www.clarity.ms/tag/' + i;
    const y = l.getElementsByTagName(r)[0];
    if (y?.parentNode) {
      y.parentNode.insertBefore(t, y);
    } else {
      l.head.appendChild(t);
    }
  })(window, document, 'clarity', 'script', projectId);
};
